import { Search } from "lucide-react";
import { useSearch } from "./useSearch";

/**
 * SearchTrigger renders a search icon button.
 *
 * Usage:
 *   <SearchTrigger context="sidebar" />   — in MainLeftSidebar
 *   <SearchTrigger context="navbar" />    — in MainNavbar
 */
export default function SearchTrigger({ context = "sidebar" }) {
  const { toggle } = useSearch();
  const isMac =
    typeof navigator !== "undefined" &&
    /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
  const shortcut = isMac ? "⌘K" : "Ctrl K";

  if (context === "navbar") {
    return (
      <button
        onClick={toggle}
        aria-label="Search"
        title={`Search (${shortcut})`}
        className="relative flex items-center justify-center w-9 h-9 rounded-lg border border-transparent transition hover:bg-mainButtonBg/50 hover:border-surfaceBorder outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60 cursor-pointer"
      >
        <Search
          strokeWidth={1.5}
          className="h-[18px] w-[18px] text-mutedText transition-colors duration-200"
        />
      </button>
    );
  }

  // sidebar context
  return (
    <button
      onClick={toggle}
      aria-label="Search"
      title={`Search (${shortcut})`}
      className="group w-full flex items-center gap-x-2.5 rounded-lg px-2.5 py-1.5 border border-transparent transition-all duration-200 ease-out hover:bg-mainButtonBg/50 outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60 cursor-pointer"
    >
      <Search
        strokeWidth={1.5}
        className="h-[18px] w-[18px] shrink-0 text-mutedText group-hover:text-mainText transition-colors duration-200"
      />
      <span className="truncate text-[13px] font-normal tracking-wide text-mutedText group-hover:text-mainText transition-colors duration-200">
        Search
      </span>
      <span className="ml-auto text-[11px] font-normal tracking-wide text-mutedText group-hover:text-mutedText transition-colors duration-200">
        {shortcut}
      </span>
    </button>
  );
}
